import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

const images = [
  "./img/rauty/rauty-1.jpg",
  "./img/rauty/rauty-2.jpg",
  "./img/rauty/rauty-3.jpg",
  "./img/rauty/rauty-4.jpg",
  "./img/rauty/rauty-5.jpg",
  "./img/rauty/rauty-6.jpg",
  "./img/rauty/rauty-7.jpg",
  "./img/rauty/rauty-8.jpg",
  "./img/rauty/rauty-9.jpg",
  "./img/rauty/rauty-10.jpg",
  "./img/rauty/rauty-11.jpg",
  "./img/rauty/rauty-12.jpg",
  "./img/rauty/rauty-13.jpg",
  "./img/rauty/rauty-14.jpg",
  "./img/rauty/rauty-15.jpg",
  "./img/rauty/rauty-16.jpg",
  "./img/rauty/rauty-17.jpg",
  "./img/rauty/rauty-18.jpg",
  "./img/rauty/rauty-19.jpg",
  "./img/rauty/rauty-20.jpg",
];

const FotogalerieRauty: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Rauty | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Fotogalerie rautů v Hospůdce pod Rablinů – firemní akce, oslavy a catering."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLOVANÝ) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= NADPIS ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            RAUTY
          </h1>
        </section>

        {/* ================= GALERIE ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
            "
          >
            {images.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Raut ${i + 1}`}
                className="
                  w-full
                  h-64
                  object-cover
                  rounded-xl
                  shadow-md
                  hover:scale-[1.02]
                  transition-transform
                  duration-300
                "
              />
            ))}
          </div>
        </section>

        {/* ================= FOOTER (ABSOLUTNÍ RESET) ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default FotogalerieRauty;